import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { UserService } from '../services/user.service';
import * as moment from 'moment';
import { ClientOrderService } from '../clientorderreport/clientorderreport.service';
import { TableUtil } from '../admintrademaster/tableUtil';
import { AddExchangeTrade } from '../addexchangetrade/addexchangetrade.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from 'angular2-notifications';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-exchangetradereport',
    templateUrl: './exchangetradereport.component.html',
    styleUrls: ['./exchangetradereport.component.css']
})
export class ExchangeTradeReportComponent implements OnInit {
    displayedColumns = ['TradeTS', 'Pair', 'Side', 'OrderType', 'OrderSource', 'Exchange', 'OrderId', 'ClientOrderId', 'TradeId',  'Quantity', 'Price', 'FillQuantity', 'AvgFillPrice', 'TradeAmount', 'Fee', 'FeeCurrency', 'OrderStatus', 'PositionCalc', 'IsActive', 'action'];
    dataSource: MatTableDataSource<ExchangeTradeData>;
    pageSize = 25;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    constructor(
        private clientService: ClientOrderService, 
        private userService: UserService,
        public dialog: MatDialog,
        public notifSer: NotificationsService,
        ) { }

    ngOnInit() {
        this.exchangeTradeReports();
        this.csrf();
        const fDate = Date.UTC(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate());
        const tDate = Date.UTC(this.selectedDate1.getFullYear(), this.selectedDate1.getMonth(), this.selectedDate1.getDate()) + 86400000; // add one day's worth of milliseconds
        this.filter['fDate'] = fDate;
        this.filter['tDate'] = tDate;
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).valueOf();
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).valueOf();
        this.filter['tDate'] = this.toDate;
    }
    async applyFilterDate() {
        await this.exchangeTradeReports();
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    deleteManualTrade(TradeId) {
        console.log(TradeId);
        try {
            this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    message: `Are you sure want to  delete exchange trade?`,
                    buttonText: {
                        ok: 'Yes',
                        cancel: 'No'
                    }
                }
            }).afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    const { notif } = defaults;
                    this.clientService.deleteExchangeTrade(TradeId).subscribe(delRes => {
                        if (delRes) {
                            this.notifSer.success('Success', delRes.Message, notif)
                            this.exchangeTradeReports();
                        }
                        else this.notifSer.error('Error', delRes.Message, notif)
                    })
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    async exchangeTradeReports() {
        await this.userService.csrf().subscribe(async (success) => {
            this.filter["_csrf"] = success._csrf;
            await this.clientService.getExchangeReportsWithFilter(this.filter).subscribe(async exchanges => {
                if (exchanges.data) {
                    let dateRes = await exchanges.data.map((exchange => {
                        exchange.TradeTS = moment(exchange.TradeTS).format('MM/DD/YY h:mm:ss A')
                        return exchange;
                    }))
                    this.dataSource = new MatTableDataSource(dateRes);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }
            })
        })
    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
    AddExchangeManualTrade() {
       try {
        var new_element = {	
            'Exchange': '',
            'Pair': "",
            'TradeDate': '',
            'Side': "",
            'Quantity': 0,
            'TradePrice': 0,
            'OrderType': '',
            'OrderId': '',
            'TradeId': '',
            'TradeTS': '',
            'ClientOrderId': '',
            'Fee': 0,
            'FeeCurrency': '',
            'BaseCurrency': '',
            'QuoteCurrency': '',
            'CommentText': '',
        }
        const dialogRef = this.dialog.open(AddExchangeTrade, {
            width: 'auto',
            data: new_element,
        }).afterClosed().subscribe(result => {
            if (result && result.success) {
                const formData = result.data;
                // Refresh the table data or perform any necessary updates
                this.exchangeTradeReports();
              }
        });
       } catch (error) {
        console.log(error);
       }

    }

    async exportArray(data = null) {
        if (this.dataSource.filteredData) {
            const ExchangeTrade = await this.dataSource.filteredData.map(x => ({
                TradeTS: x.TradeTS,
                Pair: x.Pair,
                Side: x.Side, 
                OrderType: x.OrderType,
                OrderSource: x.OrderSource,
                Exchange: x.Exchange,
                OrderId: x.OrderId,
                ExchangeTradeId: x.ExchangeTradeId,
                TradeId: x.TradeId,
                ClientOrderId: x.ClientOrderId,
                Quantity: x.Quantity,
                Price: x.Price,
                FillQuantity: x.FillQuantity,
                AvgFillPrice: x.AvgFillPrice,
                TradeAmount: x.TradeAmount,
                Fee: x.Fee,
                FeeCurrency: x.FeeCurrency,
                OrderStatus: x.OrderStatus,
                PositionCalc: x.PositionCalc,
            }));
            TableUtil.exportArrayToExcel(ExchangeTrade, "ExchangeTrade");
        }

    }


}

export interface ExchangeTradeData { 
    TradeTS: string,
    Pair: string,
    Side: string,
    OrderType: string,
    OrderSource: string,
    Exchange: string,
    OrderId: string,
    ExchangeTradeId: string,
    ClientOrderId: string,
    Quantity: number,
    Price : number,
    FillQuantity : number,
    AvgFillPrice : number,
    TradeId: string,
    TradeAmount: number,
    Fee: number,
    FeeCurrency: string,
    OrderStatus: string,
    PositionCalc: boolean,

}



// WEBPACK FOOTER //
// ./src/app/exchangetradereport/exchangetradereport.component.ts